import { TraitGroupProps } from '@design-system/trait-group';

import { traitGroupMapper } from '~/mappers/traitGroup';

import { BodyRenderExternalData, TraitGroupPIM } from './models';

export const traitGroupPIMMapper = (
  { traitSource, direction, size, textAlign, withBackground }: TraitGroupPIM,
  _currentPageUid: string,
  { salsifyExternalData }: BodyRenderExternalData
): TraitGroupProps => {
  const { productFeatures = [], secondaryFeatures = [] } = salsifyExternalData;
  const traitSourceMap = {
    product_features: productFeatures,
    secondary_features: secondaryFeatures,
  };

  const preparedItems = traitSourceMap[traitSource] || [];

  const items = preparedItems.map((item) => ({
    description: item.description,
    image: { image: item.image, alt: item.alt },
  }));

  return traitGroupMapper({
    direction,
    size,
    textAlign,
    withBackground,
    items,
  });
};
